import Tile, { TileTemplateSpec } from 'components/common/tiles/Tile';
import { ContentHub } from 'services/cwData';
import BezelButton from '../buttons/BezelButton';
import { Lightning } from '@lightningjs/sdk';

export interface BezelContentHubTileTemplateSpec extends TileTemplateSpec {
  data: ContentHub;
  imageUrl: never;

  Button: typeof BezelButton;
}

export default class BezelContentHubTile extends Tile<BezelContentHubTileTemplateSpec> {
  override _hasImageLoaded = true;

  override set data(data: BezelContentHubTileTemplateSpec['data']) {
    super.data = data;

    this.patch({
      Placeholder: { visible: false },
      Image: { visible: false },
      Button: { label: data.title, slug: data.slug },
    });
  }

  private _Button = (this as BezelContentHubTile).getByRef('Button')!;

  static override _template(): Lightning.Component.Template<BezelContentHubTileTemplateSpec> {
    return {
      ...super._template(),
      Button: {
        type: BezelButton,
        isActive: true, // prevent hover events
      },
    };
  }

  static override get width() {
    return BezelButton.width;
  }

  static override get height() {
    return BezelButton.height;
  }

  static override get highlightWidth() {
    return BezelButton.width;
  }

  static override get highlightHeight() {
    return BezelButton.height;
  }

  override updateImage() {
    // no-op
  }

  override onLoadVisibilitySignals() {
    // no-op
  }

  override _focus() {
    // call focus function without passing focus
    this._Button._focus();
  }

  override _unfocus() {
    this._Button._unfocus();
  }

  override _handleHover(target: any): boolean {
    this.fireAncestors('$onTileHovered', target);
    this._focus();
    return super._handleHover(target);
  }

  override _handleUnhover(target: any): boolean {
    this._unfocus();
    return super._handleUnhover(target);
  }
}
